import React, { Component } from "react";
import { SwaggerUIBundle } from "swagger-ui-dist";

const DisableTryItOutPlugin = function () {
  return {
    statePlugins: {
      spec: {
        wrapSelectors: {
          allowTryItOutFor: () => () => false,
        },
      },
    },
  };
};

export default class Swagger extends Component {
  componentDidMount() {
    this.getSwagger();
  }

  componentDidUpdate() {
    this.getSwagger();
  }

  getSwagger = () => {
    SwaggerUIBundle({
      // url: "./apis/users.json",
      spec: this.props.spec,
      dom_id: "#swagger-ui",
      presets: [
        SwaggerUIBundle.presets.apis,
        SwaggerUIBundle.SwaggerUIStandalonePreset,
      ],
      layout: "BaseLayout",
      plugins: [DisableTryItOutPlugin],
      supportedSubmitMethods: [],
    });
  };

  render() {
    return <div className="m-1" id="swagger-ui" />;
  }
}
